import Vue from 'vue';
import store from './../../store';
import productGroupTransformer from './../../transformers/productGroup';

const success = ({ data }, resolve) => {
  const productGroups = productGroupTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllProductGroups', productGroups);

  resolve();
};

const failed = (error, reject) => reject(error);


export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('product_groups')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/product-group/all.js